import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import startOfToday from 'date-fns__legacy__/start_of_today'
import subDays from 'date-fns__legacy__/sub_days'

const endpoint = `${apiUrl.stable}/balanco`

/**
 * Returns a balance from the current user
 * @param {number} daysFromToday How old the statement in days result should be
 * @return {Promise.<{ data: ApiWalletStatement[] }>}
 */
export const getStatement = (daysFromToday = 15) => {
  const url = `${endpoint}/extrato`

  const params = {
    DateStart: subDays(startOfToday(), daysFromToday).toISOString()
  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers, params })
}

export default {
  getStatement
}